import { mainUrl, client } from '../app-constants';

export function getPianoTechnicianList() {
    const url = mainUrl + 'pt.company/listPianoTechnician'

    return client.get(url);
}

export function getPianoTechnicianListForCompany(companyId) {
    const url = mainUrl + 'pt.company/listByCompanyId?companyId=' + companyId;

    console.log('PianoTechnicianServices.js getPianoTechnicianListForCompany url: ' + url);
    return client.get(url);
}

export function findPianoTechnician(techniciansId) {
    const url = mainUrl + 'pt.company/findPianoTechnician?techniciansId=' + techniciansId;

    return client.get(url);
}

export function savePianoTechnician(pianoTechnician, returnUpdateList) {
    const url = mainUrl + 'pt.company/savePianoTechnician';

    return client.post(url, pianoTechnician, {
        params: {
            returnUpdateList: returnUpdateList
        }
    });
}

